import React, { useState } from 'react';
import styled from '@emotion/styled';
import NoteIcon from 'ui/images/icons/note.png';

const tabData = [
    {
        key: '手数料体系',
        label: '手数料体系について',
        description:
            '着手金・中間報酬・成功報酬について確認しましょう。各手数料の有無だけでなく、計算方法や最低報酬額を確認することで、M&A時の手数料トラブル回避につながります。',
    },
    {
        key: '契約形態',
        label: '契約形態について',
        description:
            '専任契約・非専任契約の契約形態について確認しましょう。それぞれの契約形態にメリット・デメリットがあるため、自社にマッチした契約形態を選択することが重要です。',
    },
    {
        key: '買い手候補',
        label: '買い手候補について',
        description:
            'お相手となる買い手候補について確認しましょう。すでに候補となるお相手が想定できている場合や、これから買い手候補を探す場合などにより、成約スケジュールに影響を与える可能性があります。自社にマッチした買い手候補と出会える可能性が高いほど、M&Aの成功につながります。',
    },
    {
        key: '成約までの期間',
        label: '成約までの期間について',
        description:
            'M&Aに要する期間について、各仲介会社ごとに期間が異なります。平均成約期間、資料作成期間など、時間軸を知ることは重要です。',
    },
    {
        key: '担当者について',
        label: '担当者について',
        description:
            '貴社を担当する担当者や、仲介会社に所属しているメンバーについて確認しましょう。M&Aを成功させるためには、信頼できる担当者と巡り合うことも重要な要素です。',
    },
    {
        key: '契約解除時の対応',
        label: '契約解除時の対応について',
        description: 'M&Aを取りやめる場合など、契約解除時の条件や費用について確認しましょう。',
    },
    {
        key: '株価評価方法',
        label: '株価評価方法について',
        description:
            '相続税評価株価と異なり、M&A時の株価は一律ではありません。自社の株価の評価方法について確認を行い、納得のいく条件を比較することが重要です。',
    },
    {
        key: '秘密保持',
        label: '秘密保持について',
        description:
            'M&Aに関する情報は機密情報です。自社の情報がしっかりと守られるか確認をするために、情報管理体制や秘密保持契約についても確認をしましょう。',
    },
    {
        key: '税務・法務サポート',
        label: '税務・法務サポートについて',
        description:
            'M&Aに際しては、税務・法務等のプロフェッショナルなサポートが必要となるケースがあります。仲介会社ごとにサポート体制が異なるため、安心してM&Aに取り組めるよう確認しておくことが重要です。また、M&Aに関する業務の中には、弁護士や税理士などの専門家にしか認められていないもの（非弁行為等）がございます。必要に応じて専門家へご相談ください。',
    },
    {
        key: '希望スケジュール',
        label: '希望スケジュールについて',
        description:
            'M&Aを進めるにあたり、希望スケジュールがある場合には確認を行いましょう。すぐにM&Aを成立させたい・数年後にM&Aを行いたい・じっくりと時間をかけてM&Aを行いたい、など自社の希望スケジュールに沿った対応が可能かどうか比較を行うことが重要です。',
    },
];

const CardContainer = styled.div`
    width: 100%;
    margin: 0 auto 32px auto;
    background: #fff8e1;
    border-radius: 16px;
    box-shadow: 0 4px 16px #ffe08255;
    padding: 15px;
`;

const Title = styled.div`
    font-weight: 700;
    font-size: 20px;
    margin-bottom: 5px;
    color: #222;
    display: flex;
    align-items: center;
`;

const TabList = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 18px;
`;

const TabButton = styled.button<{ active: boolean }>`
    padding: 7px 14px;
    background: ${({ active }) => (active ? '#FFC107' : '#FFD54F')};
    color: #222;
    border: none;
    border-radius: 6px;
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
    box-shadow: ${({ active }) => (active ? '0 2px 8px #ffe082' : 'none')};
    transition: background 0.2s, box-shadow 0.2s;
    letter-spacing: 0.01em;
`;

const ContentBox = styled.div`
    background: #fff;
    color: #222;
    border-radius: 8px;
    padding: 12px 18px;
    font-size: 14px;
    line-height: 1.8;
    margin-top: 8px;
    white-space: pre-line;
    box-shadow: 0 2px 8px #ffe08233;
    font-weight: 600;
`;

export const TipsForQuestionnaires: React.FC = () => {
    const [activeTab, setActiveTab] = useState(tabData[0].key);
    const current = tabData.find((tab) => tab.key === activeTab);

    return (
        <CardContainer>
            <Title>
                <img src={NoteIcon} alt="ノートイラスト" style={{ width: '54px' }} />
                面談時に必ず聞くべきポイント10項目！
            </Title>
            <TabList>
                {tabData.map((tab) => (
                    <TabButton key={tab.key} active={activeTab === tab.key} onClick={() => setActiveTab(tab.key)}>
                        {tab.label}
                    </TabButton>
                ))}
            </TabList>
            {current && <ContentBox>{current.description}</ContentBox>}
        </CardContainer>
    );
};
